const styleSheet = {
  "@global": {
    body: {
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
      backgroundColor: "#fff",
      "& div#registration-app": {
        backgroundColor: "#fff"
      }
    }
  }
};

export default styleSheet;
